export const accessEndpoints = {
  adjustments: (userId: string) => `/access/users/${userId}/adjustments`,
  clientAssignment: (userId: string, tenantId: string) =>
    `/access/users/${userId}/scope/${tenantId}/clients`,
  scopeRule: (userId: string, tenantId: string, box: string) =>
    `/access/users/${userId}/scope/${tenantId}/rules/${box}`,
  scopeOptions: "/access/scope/options",
  temporaryRoles: (userId: string) => `/access/users/${userId}/temporary-roles`,
};
